import { Product } from '../../../models/Product';
import './ProductImageGallery.less';
import { useState } from 'preact/hooks';
import emptyImage from '../../../img/empty-image.svg';
import useAppSelector from '../../../hooks/useAppSelector';

export type ProductImageGalleryProps = {
    product: Product;
};

const ProductImageGallery = ({ product }: ProductImageGalleryProps) => {
    const hasImages = product.images && product.images.length > 0;
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [fadeState, setFadeState] = useState<'idle' | 'fade-out' | 'fade-in'>(
        'idle'
    );
    const [nextIndex, setNextIndex] = useState<number | null>(null);
    const aspectRatio = useAppSelector(state => state.uiState.aspectRatio);

    if (!hasImages) {
        return (
            <div
                className="bri-ProductImageGallery-empty"
                style={{ aspectRatio }}
            >
                <img src={emptyImage} />
            </div>
        );
    }

    const handleThumbnailClick = (index: number) => {
        if (index === selectedIndex || fadeState !== 'idle') {
            return;
        }
        setNextIndex(index);
        setFadeState('fade-out');
    };

    const handleTransitionEnd = () => {
        if (fadeState === 'fade-out' && nextIndex !== null) {
            setSelectedIndex(nextIndex);
            setFadeState('fade-in');
        } else if (fadeState === 'fade-in') {
            setFadeState('idle');
            setNextIndex(null);
        }
    };

    const showIndex =
        fadeState === 'fade-out'
            ? selectedIndex
            : nextIndex !== null
              ? nextIndex
              : selectedIndex;
    const imgClass =
        fadeState === 'fade-out'
            ? 'bri-fade-out'
            : fadeState === 'fade-in'
              ? 'bri-fade-in'
              : '';

    return (
        <div className={`bri-ProductImageGallery`}>
            <div className={`bri-ProductImageGallery-main-image`}>
                <img
                    src={product.images[showIndex].url}
                    alt={product.images[showIndex].altText}
                    className={imgClass}
                    onTransitionEnd={handleTransitionEnd}
                    style={{ aspectRatio }}
                />
            </div>
            <div className={`bri-ProductImageGallery-thumbnails`}>
                {product.images.map((image, index) => (
                    <img
                        key={image.url}
                        src={image.url}
                        alt={image.altText}
                        className={`bri-ProductImageGallery-thumbnail${
                            selectedIndex === index ? ' bri-selected' : ''
                        }`}
                        onClick={() => handleThumbnailClick(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProductImageGallery;
